import React from 'react';
import { Box, Typography } from '@lucid/lego';
import { useStore } from '../../../store/store';

const Campaigns: React.FC = () => {
  const theme = useStore((state) => state.theme);

  return (
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        Campaigns
      </Typography>
      <Box pt={24}>
        <Typography variant="body" size="medium" color="white" theme={theme}>
          Campaigns content will go here.
        </Typography>
      </Box>
    </Box>
  );
};

export default Campaigns;
